module.exports = "<jf-table-view ng-if=\"jfRetryMessages.showGrid\" options=\"jfRetryMessages.retryTableViewOptions\"></jf-table-view>"


//////////////////
// WEBPACK FOOTER
// ./modules/xray/directives/jf_retry_messages/jf_retry_messages.html
// module id = 573
// module chunks = 9